// TODO: resolve CHCP disables by bot
/* eslint-disable sonarjs/no-duplicated-branches */
import * as libActions from './manage-user-access.actions';

import {
  User,
  EditedUser,
  JobRole,
  EntitlementRole,
  TinAccess,
  EditedUserRejected,
  EligibleJobRoles,
  UserTinLob,
} from '../manage-access.model';

import {
  SELECTED_USER_TYPE,
  FILTER_GROUP,
  ASSIGNMENT_METHOD,
  JOB_ROLE_DELEGATE_NAME,
  USER_LOADING_STAGE,
} from '../manage-access.constant';
import { ServiceError, TinLob } from '@cigna/chcp/shared/util';
export const MANAGE_ACCESS_FEATURE_KEY = 'manageUserAccess';

export interface ManageUserAccessState {
  // app data state
  users: User[];
  jobRoles: JobRole[];
  entitlements: EntitlementRole[];
  eligibleJobRoles: EligibleJobRoles | null;
  allTins: TinAccess[];
  // ui state
  userTableView: USER_LOADING_STAGE;
  pageOverviewFilterGroup: FILTER_GROUP;
  pageOverviewFilterText: string;
  viewingUser: User | null;
  submitting: boolean;
  submitError: ServiceError | null;
  viewAccessView: string;
  removeAccessView: string;
  resetPasswordView: string;
  resetPasswordResponse: string;
  isVendorSuccess: boolean;
  // edit state
  selectedUsers: EditedUser[];
  selectedUserType: string;
  assignmentMethod: string;
  bulkEditSelectedTins: TinLob[];
  bulkEditSelectedEntitlements: EntitlementRole[];
  usersOverTinLimit: EditedUserRejected[];
  usersOverDelegateLimit: EditedUserRejected[];
  usersLastAMForTin: EditedUserRejected[];
  selectedEmailPrintUsers: EditedUser[];
  allTinsLoaded: boolean;
  userTinLobLoading: boolean;
  updateUserTinSuccess: boolean;
  userTinsWithLob: UserTinLob[];
}

export interface ManageAccessPartialState {
  readonly [MANAGE_ACCESS_FEATURE_KEY]: ManageUserAccessState;
}

export const initialState: ManageUserAccessState = {
  // app state
  users: [],
  jobRoles: [],
  entitlements: [],
  eligibleJobRoles: null,
  allTins: [],
  // ui state
  userTableView: USER_LOADING_STAGE.loading,
  pageOverviewFilterGroup: FILTER_GROUP.awaiting,
  pageOverviewFilterText: '',
  viewingUser: null,
  submitting: false,
  submitError: null,
  viewAccessView: 'loading',
  removeAccessView: 'edit',
  resetPasswordView: 'edit',
  resetPasswordResponse: '',
  isVendorSuccess: true,
  // edit state
  selectedUsers: [],
  selectedUserType: SELECTED_USER_TYPE.new,
  assignmentMethod: ASSIGNMENT_METHOD.individual,
  bulkEditSelectedTins: [],
  bulkEditSelectedEntitlements: [],
  usersOverTinLimit: [],
  usersOverDelegateLimit: [],
  usersLastAMForTin: [],
  selectedEmailPrintUsers: [],
  allTinsLoaded: false,
  userTinLobLoading: false,
  updateUserTinSuccess: false,
  userTinsWithLob: [],
};

// TODO: resolve CHCP disables by bot
// eslint-disable-next-line sonarjs/cognitive-complexity
export function manageUserAccessReducer(
  state: ManageUserAccessState = initialState,
  action: libActions.ManageUserAccessAction,
): ManageUserAccessState {
  // TODO: resolve CHCP disables by bot
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (action.type) {
    case libActions.RESET: {
      return {
        ...initialState,
        users: state.users,
        jobRoles: state.jobRoles,
        entitlements: state.entitlements,
        allTins: state.allTins,
        eligibleJobRoles: state.eligibleJobRoles,
        allTinsLoaded: state.allTins?.length > 0,
      };
    }
    case libActions.GET_ALL_USERS:
    case libActions.GET_PENDING_USERS:
    case libActions.GET_APPROVED_USERS: {
      return {
        ...state,
        userTableView: USER_LOADING_STAGE.loading,
      };
    }
    case libActions.GET_USERS_CACHED: {
      return {
        ...state,
        userTableView: USER_LOADING_STAGE.loaded_all,
      };
    }
    case libActions.GET_ALL_USERS_SUCCESS: {
      return {
        ...state,
        users: action.payload,
        selectedUsers: state.selectedUsers.map((user) => {
          const userData = action.payload.find(
            (load: User) => load.id === user.id,
          );
          return {
            ...user,
            lob: userData?.lob || user.lob,
            lobPref: userData?.lobPref || user.lobPref,
          };
        }),
        userTableView: USER_LOADING_STAGE.loaded_all,
      };
    }
    case libActions.GET_PENDING_USERS_SUCCESS: {
      return {
        ...state,
        users: action.payload,
        userTableView: USER_LOADING_STAGE.loaded_pending,
      };
    }

    case libActions.GET_ALL_USERS_ERROR: {
      return {
        ...state,
        userTableView: USER_LOADING_STAGE.error,
      };
    }
    case libActions.GET_APPROVED_USERS_SUCCESS: {
      return {
        ...state,
        userTableView: USER_LOADING_STAGE.loaded_all,
        users: [...state.users]
          .concat(action.payload)
          .sort((a: User, b: User) => {
            if (a.lastName < b.lastName) {
              return -1;
            }
            if (a.lastName > b.lastName) {
              return 1;
            }
            return 0;
          }),
      };
    }
    case libActions.GET_USER_TIN_ENTITLEMENTS_SUCCESS: {
      return {
        ...state,
        selectedUsers: action.payload,
      };
    }
    case libActions.GET_JOB_ROLES_SUCCESS: {
      return {
        ...state,
        jobRoles: action.payload,
      };
    }
    case libActions.GET_ENTITLEMENTS_SUCCESS: {
      return {
        ...state,
        entitlements: action.payload,
      };
    }
    case libActions.GET_ELIGIBLE_JOB_ROLES_SUCCESS: {
      return {
        ...state,
        eligibleJobRoles: action.payload,
      };
    }
    case libActions.GET_ALL_TINS_SUCCESS: {
      return {
        ...state,
        allTins: action.payload,
        allTinsLoaded: true,
      };
    }
    case libActions.PAGE_OVERVIEW_FILTER_GROUP_CHANGE: {
      return {
        ...state,
        pageOverviewFilterText: '',
        pageOverviewFilterGroup: action.payload,
      };
    }
    case libActions.PAGE_OVERVIEW_FILTER_TEXT_CHANGE: {
      return {
        ...state,
        pageOverviewFilterText: action.payload,
      };
    }
    case libActions.VIEW_ACCESS_FOR_USER_SUCCESS: {
      return {
        ...state,
        viewingUser: action.payload,
        viewAccessView: 'edit',
      };
    }
    case libActions.VIEW_ACCESS_FOR_USER_ERROR: {
      return {
        ...state,
        viewAccessView: 'error',
      };
    }
    case libActions.VIEW_ACCESS_FOR_USER_RESET: {
      return {
        ...state,
        viewAccessView: 'loading',
        viewingUser: null,
      };
    }
    case libActions.USER_REMOVE_ACCESS: {
      return {
        ...state,
        removeAccessView: 'loading',
      };
    }
    case libActions.USER_REMOVE_ACCESS_SUCCESS: {
      return {
        ...state,
        removeAccessView: 'success',
      };
    }
    case libActions.USER_REMOVE_ACCESS_ERROR: {
      return {
        ...state,
        removeAccessView: 'error',
      };
    }
    case libActions.USER_REMOVE_ACCESS_RESET: {
      return {
        ...state,
        removeAccessView: 'edit',
      };
    }
    case libActions.USER_RESET_PASSWORD: {
      return {
        ...state,
        resetPasswordView: 'loading',
        resetPasswordResponse: '',
      };
    }
    case libActions.USER_RESET_PASSWORD_SUCCESS: {
      return {
        ...state,
        resetPasswordView: 'success',
        resetPasswordResponse: action.payload.temporaryPassword,
        users: state.users.map((user) =>
          user.id === action.payload.userId
            ? {
                ...user,
                temporaryPassword: action.payload.temporaryPassword,
              }
            : user,
        ),
      };
    }
    case libActions.USER_RESET_PASSWORD_ERROR: {
      return {
        ...state,
        resetPasswordView: 'error',
      };
    }
    case libActions.USER_RESET_PASSWORD_RESET: {
      return {
        ...state,
        resetPasswordView: 'edit',
        resetPasswordResponse: '',
      };
    }
    case libActions.ADD_NEW_USERS: {
      return {
        ...state,
        selectedUsers: [],
      };
    }
    case libActions.SELECT_AND_EDIT_USER: {
      return {
        ...state,
        viewAccessView: 'loading',
        viewingUser: null,
        selectedUsers: [
          {
            ...action.payload,
            accessBefore: [],
            accessAfter: [],
          },
        ],
        selectedUserType: SELECTED_USER_TYPE.exisiting,
      };
    }
    case libActions.VIEW_AND_EDIT_USERS:
    case libActions.LOAD_USERS_FROM_DASHBOARD: {
      return {
        ...state,
        selectedUserType: SELECTED_USER_TYPE.exisiting,
      };
    }
    case libActions.LOAD_USERS_FROM_DASHBOARD_SUCCESS: {
      return {
        ...state,
        users: action.payload.users,
        selectedUsers: action.payload.selectedUsers,
      };
    }
    case libActions.SET_ASSIGNMENT_METHOD_AND_ASSIGN: {
      return {
        ...state,
        assignmentMethod: action.payload,
      };
    }
    case libActions.SELECT_USER_TO_EDIT: {
      return {
        ...state,
        selectedUsers: [
          ...state.selectedUsers,
          {
            ...action.payload,
            accessBefore: [],
            accessAfter: [],
          },
        ],
      };
    }
    case libActions.UNSELECT_USER_TO_EDIT: {
      return {
        ...state,
        selectedUsers: state.selectedUsers.filter(
          (user) => user.id !== action.payload.id,
        ),
      };
    }
    case libActions.UNSELECT_ALL_USERS_TO_EDIT: {
      return {
        ...state,
        selectedUsers: [],
      };
    }
    case libActions.ADD_USERS_AND_START_ASSIGNMENT:
    case libActions.SET_SELECTED_USERS:
    case libActions.SCAFFOLD_SELECTED_USERS: {
      return {
        ...state,
        selectedUsers: action.payload,
      };
    }
    case libActions.SELECT_USER_TO_PRINT_EMAIL: {
      return {
        ...state,
        selectedEmailPrintUsers: [
          ...state.selectedEmailPrintUsers,
          action.payload,
        ],
      };
    }
    case libActions.UNSELECT_USER_TO_PRINT_EMAIL: {
      return {
        ...state,
        selectedEmailPrintUsers: state.selectedEmailPrintUsers.filter(
          (user) => user.id !== action.payload.id,
        ),
      };
    }
    case libActions.SELECT_ALL_USERS_TO_PRINT_EMAIL: {
      return {
        ...state,
        selectedEmailPrintUsers: action.payload ? state.selectedUsers : [],
      };
    }
    case libActions.CANCEL_EDIT_USER_FLOW: {
      return {
        ...state,
        selectedUsers: [],
        selectedUserType: SELECTED_USER_TYPE.new,
        assignmentMethod: ASSIGNMENT_METHOD.individual,
        submitError: null,
        bulkEditSelectedEntitlements: [],
        bulkEditSelectedTins: [],
        usersOverDelegateLimit: [],
        usersOverTinLimit: [],
        selectedEmailPrintUsers: [],
      };
    }
    case libActions.UPDATE_EDITED_USER_INDIVIDUAL: {
      return {
        ...state,
        selectedUsers: state.selectedUsers.map((user) =>
          user.id === action.payload.user.id
            ? {
                ...user,
                accessAfter: user.accessAfter.map((tin: TinAccess) =>
                  tin.tin === action.payload.tin.tin
                    ? {
                        ...tin,
                        entitlements: action.payload.entitlements,
                      }
                    : tin,
                ),
              }
            : user,
        ),
      };
    }
    case libActions.UPDATE_EDITED_USERS_BULK_TINS: {
      return {
        ...state,
        bulkEditSelectedTins: action.payload,
      };
    }
    case libActions.UPDATE_EDITED_USERS_BULK_ENTITLEMENTS: {
      return {
        ...state,
        bulkEditSelectedEntitlements: action.payload,
      };
    }
    case libActions.UPDATE_EDITED_USERS_BULK_AND_CONTINUE: {
      return {
        ...state,
        selectedUsers: action.payload,
      };
    }
    case libActions.SHOW_EDIT_ERRORS: {
      return {
        ...state,
        submitting: false,
        submitError: null,
        usersOverTinLimit: action.payload.overTinLimit.map((userObj) => ({
          user: state.selectedUsers.find((user) => user.id === userObj.userId),
        })),
        usersOverDelegateLimit: action.payload.overDelegateLimit.map(
          (userObj) => ({
            user: state.selectedUsers.find(
              (user) => user.id === userObj.userId,
            ),
            tin: userObj.tin,
            tinName: userObj.tinName,
          }),
        ),
        usersLastAMForTin: action.payload.lastAMForTin.map((userObj) => ({
          user: state.selectedUsers.find((user) => user.id === userObj.userId),
          tin: userObj.tin,
          tinName: userObj.tinName,
        })),
        // pageScreen: PAGE_SCREEN.interstitial,
      };
    }
    case libActions.PROCEED_WITH_EDIT_ERRORS: {
      return {
        ...state,
        selectedUsers: state.selectedUsers
          // drop user from selected users if they are over tin limit
          .filter(
            (user) =>
              user &&
              state.usersOverTinLimit.findIndex(
                (u) => u.user !== undefined && u.user.id === user.id,
              ) === -1,
          )
          // strip delegate role for user/tin over delegate limit
          .map((user) => ({
            ...user,
            accessAfter: user.accessAfter.map((tin) =>
              state.usersOverDelegateLimit.find(
                (u) =>
                  u.user !== undefined &&
                  u.user.id === user.id &&
                  u.tin === tin.tin,
              )
                ? {
                    ...tin,
                    entitlements: tin.entitlements
                      ? tin.entitlements.filter(
                          (entitlement) =>
                            entitlement.name !== JOB_ROLE_DELEGATE_NAME,
                        )
                      : [],
                  }
                : tin,
            ),
          }))
          // add back delegate role for user that was only delegate on a tin
          .map((user) => {
            const delegateEntitlement = state.entitlements.find(
              (entitlement) => entitlement.name === JOB_ROLE_DELEGATE_NAME,
            );
            return {
              ...user,
              accessAfter: user.accessAfter.map((tin) =>
                state.usersLastAMForTin.find(
                  // TODO: resolve CHCP disables by bot
                  // eslint-disable-next-line sonarjs/no-identical-functions
                  (u) =>
                    u.user !== undefined &&
                    u.user.id === user.id &&
                    u.tin === tin.tin,
                )
                  ? {
                      ...tin,
                      entitlements:
                        tin.entitlements && delegateEntitlement
                          ? tin.entitlements.concat(delegateEntitlement)
                          : [],
                    }
                  : tin,
              ),
            };
          }),
      };
    }
    case libActions.ADD_USERS_SUBMIT:
    case libActions.ASSIGN_USERS_SUBMIT: {
      return {
        ...state,
        submitting: true,
        submitError: null,
      };
    }
    case libActions.ADD_USERS_NO_LOB_ERROR: {
      return {
        ...state,
        submitting: false,
      };
    }
    case libActions.ADD_USERS_ERROR:
    case libActions.ASSIGN_USERS_ERROR: {
      return {
        ...state,
        submitting: false,
        submitError: action.payload,
      };
    }
    case libActions.ASSIGN_USERS_SUCCESS:
    case libActions.ADD_USERS_SUCCESS: {
      return {
        ...state,
        submitting: false,
        // pageScreen: PAGE_SCREEN.receive,
        submitError: null,
        isVendorSuccess:
          !action.payload.vendorStatus ||
          action.payload.vendorStatus.code === 0,
      };
    }

    case libActions.ADD_USERS_SUCCESS_MERGE: {
      return {
        ...state,
        selectedUsers: action.payload,
      };
    }
    case libActions.GET_USER_TIN_LOB: {
      return {
        ...state,
        userTinLobLoading: true,
        updateUserTinSuccess: false,
        userTinsWithLob: [],
      };
    }
    case libActions.GET_USER_TIN_LOB_SUCCESS: {
      return {
        ...state,
        userTinLobLoading: false,
        userTinsWithLob: action.userTins,
      };
    }
    case libActions.UPDATE_USER_TIN_LOB: {
      return {
        ...state,
        userTinLobLoading: true,
        updateUserTinSuccess: false,
      };
    }
    case libActions.UPDATE_USER_TIN_LOB_SUCCESS: {
      return {
        ...state,
        updateUserTinSuccess: true,
        userTinLobLoading: false,
        users: [
          ...state.users.map((user) =>
            user.id === action.payload.userId
              ? { ...user, lobPref: action.payload.lobPref }
              : user,
          ),
        ],
        selectedUsers: [
          ...state.selectedUsers.map((usr) =>
            usr.id === action.payload.userId
              ? { ...usr, lobPref: action.payload.lobPref }
              : usr,
          ),
        ],
      };
    }

    default: {
      return state;
    }
  }
}
